import _ from 'lodash';

import RefData from 'ref-data';
import { Experience, Workspace } from 'common-entities';

import { getStore } from '../../common/redux/store-utils';

/**
 * function will try to get the experience object from the redux state if possible, OR fall back to the old App.Campaign object
 */
const getCompatibleExperience = () => {
  const state = getStore().getState();
  const experience = Experience.Selectors.experience(state);
  return _.get(experience, 'formatType.id', false) === RefData.Enum.FORMAT.DISPLAY.MICRO
    ? Workspace.Selectors.activeWorkspace(state).merge(experience)
    : _.get(window, 'App.Campaign');
};

/**
 * There are some areas of the new app where we need to navigate back to the `grails-app/`.
 * This is intended simply to provide an easy way to grep (find) those areas as we convert the legacy to the new so that we don't breaking navigation.
 * @param {string} url - the url to navigate to
 */
function navigateToLegacyPage(url) {
  return new Promise((resolve) => {
    const _url = _.startsWith(url, '/') ? url : '/' + url;
    window.location = `${App.globalContext.serverURL}${_url}`;
    resolve();
  });
}

export { getCompatibleExperience, navigateToLegacyPage };
